module.exports = __webpack_public_path__ + "img/2023-07.a9add255.jpg";